export enum QUERY_KEYS {
  getEventTeamChannels = 'event-team-channels',
}
